import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VaProductPageComponent, ProductListPageTableViewComponent } from '@vendasta/sales-ui';
import { AccessTrainingResourcesPageGuard } from '../core/guards/access-training-resources-page-guard.service';

export const TRAINING_RESOURCES_PAGE_ROUTES = {
  PRODUCTS_LIST: 'products',
  PRODUCT: 'product/:productId',
};

const routes: Routes = [
  {
    path: '',
    redirectTo: TRAINING_RESOURCES_PAGE_ROUTES.PRODUCTS_LIST,
    pathMatch: 'full',
  },
  {
    path: TRAINING_RESOURCES_PAGE_ROUTES.PRODUCT,
    component: VaProductPageComponent,
    canActivate: [AccessTrainingResourcesPageGuard],
  },
  {
    path: TRAINING_RESOURCES_PAGE_ROUTES.PRODUCTS_LIST,
    component: ProductListPageTableViewComponent,
    canActivate: [AccessTrainingResourcesPageGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrainingResourcesRouting {}
